/**
 * @override BasePageFragment
 * `homePage`: omitted — use CMS `pageType` `homepage` → body `page--home-page`.
 * `pageType`: when set, drives `document.body` class `page--<slug>`; empty falls back to inferred type.
 */

import gql from 'graphql-tag';

export const BasePageFragment = gql`
  fragment BasePageFragment on Page {
    __typename
    sys {
      id
    }
    categoryId
    pageType
    productId
    regions
    slug
    storeId
    title
    contentfulMetadata {
      tags {
        id
      }
    }
  }
`;
